var { isMobile } = require("./lib/breakpoints");

var { Sidechain } = require("@nprapps/sidechain");
var $ = require("./lib/qsa");
Sidechain.registerGuest();
let dot = require("./lib/dot");
let tableTemplate = dot.compile(require("./_table.html"));
var L = require("leaflet");

console.clear();

// constants
const SPIKE_MAX = 70;
const PEAK_WINDOW = 5;
const THRESHOLDS = {
  "#784B38": -10000,
  "#C47C5C": -5000,
  "#F79C75": -1000,
  "#DCDCDC": 0,
  "#FFFFFF": 0.1,
  "#DCDCDC": 1000,
  "#9CD1D4": 5000,
  "#19A4AB": 10000,
  "#178287": Infinity,
};

// Set up select boxes, table container, map container

var selectState = $.one(".select-state");
var selectDistrict = $.one(".select-district");
var tableContainer = $.one(".district-table");
var mapContainer = $.one("#map");
var map = L.map("map", {
  zoomSnap: 0.1,
  zoomControl: false,
  attributionControl: false,
  scrollWheelZoom: false,
  dragging: false,
  boxZoom: false,
});

// Variables to reset map features when changing states

var stateCache = {};
const districtLookup = {};
var mapBounds = null;

// Recenters the map after closing a popup or resizing window

let reCenter = function () {
  if (mapBounds) {
    map.fitBounds(mapBounds);
    map.invalidateSize();
  }
};

// Caches shapefiles for faster loading

async function getShapefile(name) {
  if (!stateCache[name]) {
    stateCache[name] = fetch(`./synced/states/${name}.geojson`).then(
      (request) => request.json()
    );
  }
  return stateCache[name];
}

// Activates on selection of state -- clears old map and renders new

function loadMap(json) {
  map.eachLayer((layer) => map.removeLayer(layer));
  map.invalidateSize();

  // formats variables for table view

  var convert = "enroll ppcstot fundinggap".split(" ");
  for (var { properties } of json.features) {
    for (var p of convert) {
      properties[p] = Number(properties[p]);
    }
  }

  // loads geojson and sets bounds

  let geojson = L.geoJSON(json);
  geojson.addTo(map);
  let bounds = geojson.getBounds();
  map.fitBounds(bounds);
  mapBounds = bounds;

  // establish empty table for districts

  selectDistrict.innerHTML = "";

  // sort districts alphabetically for district selectbox

  let sortedFeatures = json.features.slice();
  sortedFeatures.sort(function (a, b) {
    if (a.properties.NAME < b.properties.NAME) return -1;
    if (a.properties.NAME > b.properties.NAME) return 1;
    return 0;
  });

  // create district selection list

  for (var feature of sortedFeatures) {
    var { GEOID, NAME } = feature.properties;
    districtLookup[GEOID] = feature;

    let option = document.createElement("option");
    option.innerHTML = NAME;
    option.value = GEOID;

    selectDistrict.append(option);
  }

  // establish mins and maxes for cone-size calculation

  var enrollVals = json.features.map((f) => f.properties.enroll);

  // sort enrollment values to calculate averaged max

  let sortedEnrollVals = enrollVals.slice();
  sortedEnrollVals.sort((a, b) => a - b);

  // get actual max and mins

  let enrollMax = Math.max(...enrollVals);
  let enrollMin = Math.min(...enrollVals);

  // get range based on actual max and mins; OLD METHOD
  // let enrollRange = Math.abs(enrollMin - enrollMax);

  // get range based on averages

  // get funding gap values

  var gapVals = json.features.map((f) => f.properties.fundinggap);
  let gapMax = Math.max(...gapVals);
  let gapMin = Math.min(...gapVals);
  let gapRange = Math.abs(gapMin - gapMax);

  // get average of top n district enrollment in a state

  let topEnroll = sortedEnrollVals.slice(-PEAK_WINDOW);
  var topAvg =
    topEnroll.reduce((a, b) => a + b, 0) / topEnroll.length;
  let enrollRange = Math.abs(enrollMin - topAvg);

  // console.log({ enrollMax, topAvg, enrollRange });

  // passes range values in styleDistrict

  let config = {
    gapMin,
    gapMax,
    gapRange,
    enrollMin,
    enrollMax,
    enrollRange,
    topAvg,
  };

  var boundStyle = styleDistrict.bind(null, config);

  geojson.eachLayer(boundStyle);
}

// pulls state based on selectbox value

async function onSelectState() {
  var state = selectState.value;
  var json = await getShapefile(state);
  mapContainer.dataset.aspect = window.DATA[state].aspect;
  await loadMap(json);
  onSelectDistrict();
}

// selects colors, calculates cone sizes, assigns district style attributes

function styleDistrict(config, layer) {
  // sets colors

  let {
    fundinggap: fund,
    NAME: name,
    xcoord: lng,
    ycoord: lat,
    enroll
  } = layer.feature.properties;

  let finalColor = "#0B362A";//getColor(fund, THRESHOLDS, );
  for (var k in THRESHOLDS) {
    if (fund < THRESHOLDS[k]) {
      finalColor = k;
      break;
    }
  }

  layer.setStyle({
    fillColor: finalColor,
    fillOpacity: 0.75,
    weight: 0.5,
    color: "#393939",
  });

  // sets triangle center

  let center = new L.latLng(lat, lng);

  // get enrollment to set triangle height
  let enrollScale = Math.min(enroll / config.enrollRange, 1);

  // draws triangle svg

  var triangle = L.divIcon({
    className: "triangle",
    size: [1, 1],
    html: `<svg 
          viewBox="0 0 2 1" 
          preserveAspectRatio="none" 
          style="height:${enrollScale * SPIKE_MAX}px">
            <path 
            vector-effect="non-scaling-stroke" 
            style="fill:${finalColor}; fill-opacity:0.9" 
            stroke="#000" 
            stroke-width:"5" 
            d="M0,1 L1,0 L2,1" />
          </svg>`,
  });

  // rounding function

  function numPrep(d) {
    let num = Math.abs(d);

    return Math.round(num / 100) * 100;
  }

  // adds triangle and popup

  let underfundString = ` by approximately $${numPrep(fund).toLocaleString(undefined, {
    maximumFractionDigits: 2
  })} per student`

  let tooltipContents = `<b>${name}</b><br>
    This district is estimated to be <b>${fund < 0 ? "underfunded</b>"  + underfundString : "adequately funded</b>"}. 
    It had ${enroll.toLocaleString("en-US")} students in fall of 2018.<br>`;

  // associates table data with tooltip selection
  let updateTable = function () {
    populateTable(layer.feature.properties.GEOID);
    selectDistrict.value = layer.feature.properties.GEOID;
  };

  // hides small peaks for readability, attaches popup to peaks

  if (enroll > 0) {
    if (enrollScale > 0.028) {
      L.marker(center, { icon: triangle })
        .bindPopup(tooltipContents)
        .on("popupopen", updateTable)
        .on("popupclose", reCenter)
        .addTo(map);
    }

    // attaches popup to shapes

    layer.bindPopup(tooltipContents).addTo(map);

    // associates table data with popup behavior

    layer.on("popupopen", updateTable);

    // return map to center on popup close

    layer.on("popupclose", reCenter);
  }
}

// defaults map to open on data-state

selectState.addEventListener("change", onSelectState);
selectState.value = mapContainer.dataset.state;
onSelectState();

// populates table data

function populateTable(id) {
  let feature = districtLookup[id];
  let html = tableTemplate(feature.properties);
  tableContainer.innerHTML = html;
}

// creates popup interactions to match table interaction

function onSelectDistrict(e) {
  var id = selectDistrict.value.trim();
  populateTable(id);
  if (!e) return;
  var matching = [];
  map.eachLayer(function (layer) {
    if (!layer.feature || !layer.feature.properties) return;
    if (layer.feature.properties.GEOID == id) {
      matching.push(layer);
    }
  });
  var [first] = matching;
  if (first) first.openPopup();
}

// recenters for window resizing

window.map = map;

selectDistrict.addEventListener("change", onSelectDistrict);

window.addEventListener("resize", reCenter);
